<sm-svg-loader *ngIf="loader"></sm-svg-loader>

<div
  class="dashboard_new"
  *ngIf="!loader && upcomingAppointmentsData.length == 0"
>
  <mat-card>
    <div class="upload_sectio">
      <div class="icm_img">
        <img src="./assets/images/s2.png" />
      </div>
      <!-- will appear here. -->
      <mat-card-title>Upcoming bookings will appear here </mat-card-title>
      <mat-card-content
        >Knowing upcoming appointments allows you to allocate resources, such as
        staff and products effectively. It ensures that you should well-prepared
        to meet client demands.</mat-card-content
      >
      <!-- <div class="watch_vc_btn">
          <button mat-stroked-button color="primary" (click)="openvideo()">
             <mat-icon>smart_display</mat-icon>
             Watch video
          </button>
       </div> -->
    </div>
  </mat-card>
</div>

<!-- with data -->
<div
  class="today_booking_card"
  *ngIf="!loader && upcomingAppointmentsData.length > 0"
>
  <mat-card>
    <div class="vier_tht">
      <div class="heading_ot">
        <h3>Upcoming activity</h3>
      </div>
      <div
        class="view_all_btn"
        *ngIf="upcomingAppointmentsData[0].total_count > 4"
      >
        <a (click)="viewAll()">{{
          upcomingAppointmentsData[0].total_count > 4
            ? "View all " + upcomingAppointmentsData[0].total_count
            : "View details"
        }}</a>
      </div>
    </div>
    <!--  -->
    <div
      class="list_yy"
      *ngFor="let item of upcomingAppointmentsData"
      (click)="bookingDetails(item)"
    >
      <div class="bookign_img">
        <img
          [src]="item.customer_thumb_image"
          onerror="this.src='../../../../../../assets/images/user-avatar.svg'"
          alt=""
        />
      </div>
      <div class="booking_heading">
        <h3>
          {{ item.customer_name ? item.customer_name : "Guest Customer" }}
        </h3>
        <p>
          {{
            item.customer_phone
              ? item.country_code + " " + item.customer_phone
              : "No phone info"
          }}
        </p>
      </div>
      <div class="booking_heading">
        <h3>
          {{ item.business_name ? item.business_name : "No business info" }}
        </h3>
         <p *ngIf="item.booking_type == 0 && item.data_type == 1">
          {{
            item.booking_address && item.booking_address != '' && item.booking_address != 'null' 
              ? "Visit: " + item.booking_address.address_line
              : "No address info"
          }}
        </p>
        <p *ngIf="item.booking_type == 0 && item.data_type == 2">
          {{
            item.booking_address
              ? "Visit: " + item.booking_address
              : "No address info"
          }}
        </p>
        <p *ngIf="item.booking_type != 0">
          {{
            item.business_address
              ? item.business_address
              : "No address info"
          }}
        </p>
      </div>
      <div class="booking_heading">
        <h3>{{ item.u_booking_date }}</h3>
        <p>{{ item.bookingType ? item.bookingType : "N/A" }}</p>
      </div>
      <div
        class="status_heading"
        [class.new-booking]="
          item.appointment_status == 0 ||
          item.appointment_status == 1 ||
          item.appointment_status == 2
        "
        [class.under-process]="
          item.appointment_status == 3 ||
          item.appointment_status == 7 ||
          item.appointment_status == 9
        "
        [class.completed]="item.appointment_status == 4"
        [class.cancelled]="
          item.appointment_status == 6 || item.appointment_status == 8
        "
        [class.confirmed]="item.appointment_status == 5"
      >
        <div class="booking_done">
          <p>{{ item.bookingStat ? item.bookingStat : "No status info" }}</p>
          <p
            style="
              font-size: 12px;
              color: #1d1d1d;
              margin: 0;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
              margin-top: 5px;
              width: 65px;
            "
          >
            {{ item.employee_name ? item.employee_name : "---" }}
          </p>
        </div>
        <!-- icon alert -->
        <div class="booking_block">
          <mat-icon>arrow_forward</mat-icon>
        </div>
        <!-- icon alert -->
      </div>
    </div>
    <div
      class="list_yy"
      style="height: 61px"
      *ngFor="let item of repeatArray"
    ></div>
  </mat-card>
</div>
